import axios from 'axios'
import {uriConstants} from "../constants"

export const manageService = {
  setGroupInfo,
}

async function setGroupInfo(params) {
  const formData = new FormData()


  //params.registFile && formData.append('registFile', params.registFile, params.registFileName);

  formData.append('groupName', params.groupName);
  formData.append('groupRegistno', params.groupRegistno);
  formData.append('corpRegistno', params.corpRegistno);
  formData.append('bizcnd', params.bizcnd);
  formData.append('induty', params.induty);
  formData.append('rprsntvNm', params.rprsntvNm);
  formData.append('repTelno', params.repTelno);
  formData.append('faxNo', params.faxNo);
  formData.append('groupZipno', params.groupZipno);
  formData.append('groupAdres', params.groupAdres);
  formData.append('groupDetailAdres', params.groupDetailAdres);
  formData.append('description', params.description);

  const user = JSON.parse(localStorage.getItem('user'));

  return await axios.post(
    uriConstants.API_URI + uriConstants.SET_GROUP_INFO,
    formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: 'Bearer ' + user?.payload?.accessToken
    }
  })
}